import React from "react";
import CircleIcon from "@mui/icons-material/Circle";
import { colors } from "../styles";

/**
 * Circle Icon Component
 */
export default ({ value }) => {
    let color;
    if (value === true) color = colors.green;
    else if (value === false) color = colors.red;
    else color = colors.grey;
    return <CircleIcon sx={{ width: "0.5em", color: color }} />;
};
